import { createContext, useContext } from "react";

export const ContextInit = createContext();
const useStoreContext = () => useContext(ContextInit);
export default useStoreContext;
